import Button from '@material-ui/core/Button';
import { blue } from '@material-ui/core/colors';
import { withStyles } from '@material-ui/core/styles';

const GasButtonStyles = withStyles((theme) => ({
    root: {
      marginTop: 20,
      width: "300px",
      fontSize: 20,
      color: theme.palette.getContrastText(blue[900]),
      backgroundColor: blue[800],
      '&:hover': {
        backgroundColor: blue[700],
      },
    },
  }))(Button);

  export default GasButtonStyles;